var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.83203,
    y: 1.83203,
    width: 20.3333,
    height: 20.3333,
    rx: 10.1667,
    fill: "#F95C66",
    stroke: "#F95C66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 9.01172L9.75304 16.0395L6.55859 12.8451",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheck);
export default __webpack_public_path__ + "static/media/RedCheck.e473b2282592aca14c6919466dfaedfc.svg";
export { ForwardRef as ReactComponent };